export default {
    data() {
        return {
            garages: [],
            selectedGarage: null,
            searchValue: '',
            loading: false,
        }
    },


    filters: {
        formatDistance(value) {
            return `${value.toFixed(2)} km`;
        }
    },

    methods: {
        async fetchGarages() {
            await axios.get(`/api/garages-by-geo?searchQuery=${this.searchValue}`)
                .then(response => {
                    if (!lodash.isNil(response.data.message)) {
                        this.garages = [];
                        return;
                    }

                    this.garages = response.data;
                })
                .catch(error => {
                    this.garages = [];
                })
                .finally(() => this.loading = false);
        },

        handleSearch(payload) {
            this.loading = true;
            this.searchValue = payload;

            if (_.isEmpty(payload)) {
                this.loading = false;
                return;
            }

            this.setSearchValue();
        },

        setSearchValue: _.debounce(function() {
            this.fetchGarages();
        }, 500),
    }
}